import { render, staticRenderFns } from "./ComposeLocked.vue?vue&type=template&id=531f8c90&scoped=true&"
import script from "./ComposeLocked.vue?vue&type=script&lang=ts&"
export * from "./ComposeLocked.vue?vue&type=script&lang=ts&"
import style0 from "./ComposeLocked.vue?vue&type=style&index=0&id=531f8c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f8c90",
  null
  
)

export default component.exports